module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack($event)
      }
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Freunde von " + _vm._s(_vm._f("name")(_vm.who)))])]), _vm._v(" "), _c('section', _vm._l((_vm.who.friends), function(friend) {
    return _c('div', {
      staticClass: "item"
    }, [_c('dp', {
      attrs: {
        "who": friend
      }
    }), _vm._v(" "), _c('header', [_c('h3', [_c('router-link', {
      attrs: {
        "to": ("/profile/" + (friend.id))
      }
    }, [_vm._v("\n                        " + _vm._s(_vm._f("name")(friend)) + "\n                    ")])], 1), _vm._v(" "), _c('div', [_c('friendship-button', {
      attrs: {
        "who": friend
      }
    })], 1)])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d06581f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/friend-list.vue
// module id = 220
// module chunks = 0